import { LessonTaskStepKey } from '../../../../main/types/asset/lesson.types.ts';
import { getLessonsUtil } from '../../../../main/utils/asset/lessons.util.ts';

import { LessonSliceState } from '../lesson.slice.types.ts';

export const updateLessonTaskStepFromKey = (state: LessonSliceState, key: LessonTaskStepKey): void => {
  const lessonUtil = getLessonsUtil();
  const stepData = lessonUtil.getLessonTaskStep(key);
  if (!stepData) return;
  state.currentLesson = stepData.lesson;
  state.currentTask = stepData.task;
  state.currentStep = stepData.step;
};
